export default __webpack_public_path__ + "static/media/asset05.bd267cad.png";